import { render, staticRenderFns } from "./size.vue?vue&type=template&id=51b27456&scoped=true&"
import script from "./size.vue?vue&type=script&lang=js&"
export * from "./size.vue?vue&type=script&lang=js&"
import style0 from "./size.vue?vue&type=style&index=0&id=51b27456&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51b27456",
  null
  
)

export default component.exports